/**
                    * Created by tomers on 6/14/2015.
                    */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersGridRowView.tmpl");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");

    var Checkbox = require("ui/checkbox/Checkbox");

    var UsersGridRowView = {};

    var EMPTY_DATA = " ";

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "user-row",
            template: template,
            ui: {
                selector: ".selector",
                displayName: ".display-name",
                nickName: ".nick-name",
                loginName: ".login-name",
                permissionGroup: ".permission-group",
                groups: ".groups",
                groupsContent: ".groups .content"
            },
            uiComponents: {
                selectorCheckbox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.selector",
                        checked: false,
                        label: "",
                        permutation: Checkbox.PERMUTATION.B // no label
                    },
                    events: {
                        "change": "_onSelectorChange"
                    }
                }
            },
            events: {
                "click @ui.selector": "_onSelectorWrapperClick",
                "click @ui.displayName": "_onRowClick",
                "click @ui.nickName": "_onRowClick",
                "click @ui.loginName": "_onRowClick",
                "click @ui.permissionGroup": "_onRowClick",
                "click @ui.groups": "_onRowClick"
            },

            customTemplateHelpers: function() {
                var permissionGroupId = this.model.getPermissionGroup();
                var permissionGroupName = LEUserManagement.getDataManager().getPermissionGroupNameById(permissionGroupId);
                var loginName = this.model.getLoginName();
                var nickName =  this.model.getNickName();
                var displayName =  this.model.getDisplayName();

                return {
                    permissionGroupName: permissionGroupName,
                    loginName: loginName,
                    nickName:  nickName,
                    displayName: displayName
                };
            },

            initialize: function(options) {
                LEUserManagement.logger.debug("initialize", "UsersGridRowView:initialize");
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_LIST);
                this.agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                this.groupColumnVisible = options.groupColumnVisible;
                this._bindEvents();
            },

            onRender: function() {
                LEUserManagement.logger.debug("onRender", "UsersGridRowView:onRender");
                this._updateGroups();
                this.showGroupsColumn();
                this._updatePermissionGroup();
            },
            onClose: function(){
                LEUserManagement.logger.debug("onClose", "UsersGridRowView:onClose");
            },

            _bindEvents: function (checked) {
                LEUserManagement.logger.debug("_bindEvents", "UsersGridRowView:_bindEvents");
                this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);

                this.listenTo(LEUserManagement.getDataManager().getAgentGroupsCollection(), "fetch:success", this._updateGroups);
                this.listenTo(LEUserManagement.getDataManager().getPermissionGroupsCollection(), "fetch:success", this._updatePermissionGroup);
            },

            _onSelectorWrapperClick: function(e) {
                LEUserManagement.logger.debug("_onSelectorWrapperClick", "UsersGridRowView:_onSelectorWrapperClick");
                if ($(e.target).hasClass("selector")) {
                    this.uiComponents.selectorCheckbox.checkboxClick();
                }
            },

            _onRowClick: function() {
                LEUserManagement.logger.debug("_onRowClick", "UsersGridRowView:_onRowClick");
                this.channel.trigger("row:click", this.model);
            },

            _onSelectorChange: function(componentId, eventName, isChecked) {
                LEUserManagement.logger.debug("_onSelectorChange", "UsersGridRowView:_onSelectorChange");
                this.channel.trigger("row:selector:click", {itemModel:this.model, isChecked:isChecked});
            },

            _onModelSelectionChange: function(isChecked) {
                LEUserManagement.logger.debug("_onModelSelectionChange", "UsersGridRowView:_onModelSelectionChange");
                this.$el.toggleClass("selected", isChecked);
                this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
            },

            showGroupsColumn: function() {
                LEUserManagement.logger.debug("showGroupsColumn", "UsersGridRowView:showGroupsColumn");
                this.ui.groups.toggleClass("hide",!this.groupColumnVisible);
            },

            _updateGroups: function() {
                LEUserManagement.logger.debug("_updateGroups", "UsersGridRowView:_updateGroups");
                if (this.uiComponents.groups) {
                    this.uiComponents.groups.close();
                }

                var groups = this.model.getGroups(this.agentGroupsCollection);

                if (groups && groups.length > 0) {
                    this.uiComponents.host$.createAndRender("groups", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.groupsContent",
                            collection: "view._getGroupsCollection",
                            textModelAttr: "tooltip",
                            visibleItemsCount: 2,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                } else {
                    this.ui.groups.text(EMPTY_DATA);
                }
            },

            _updatePermissionGroup: function() {
                var permissionGroupId = this.model.getPermissionGroup();
                var permissionGroupName = LEUserManagement.getDataManager().getPermissionGroupNameById(permissionGroupId);

                if (!LEUserManagement.getDataManager().getPermissionGroupsCollection().hasAtLeastOneSuccessfulFetch()) {
                    this._showLoader("permissionGroup", true);
                }
                else {
                    this._showLoader("permissionGroup", false);
                    this.ui.permissionGroup.html(permissionGroupName);
                }
            },

            _getGroupsCollection: function() {
                LEUserManagement.logger.debug("_getGroupsCollection", "UsersGridRowView:_getGroupsCollection");
                var groups = this.model.getGroups(this.agentGroupsCollection);
                var groupsWIthToolTip = this._addToolTip(groups);
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(groupsWIthToolTip));
            },

            _addToolTip: function(groups) {
                LEUserManagement.logger.debug("_addToolTip", "UsersGridRowView:_addToolTip");
                for (var ii = 0; ii < groups.length; ii++) {
                    if (groups[ii].name) {
                        groups[ii].tooltip = groups[ii].name;
                    }
                }
                return groups;
            },

            _sortByName: function(items) {
                items.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });

                return items;
            },

            _showLoader:function (clmName, show) {
                if (show && this.ui[clmName].find(".loading").length && !this.loaders[clmName]) {
                    this.loaders[clmName] = new Loader({
                        permutation:Loader.PERMUTATION.H,
                        el:this.ui[clmName].find(".loading")
                    });
                    this.loaders[clmName].render();
                }
                else {
                    if (this.loaders[clmName]) {
                        this.loaders[clmName].close();
                        this.loaders[clmName] = null;
                    }
                }
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersGridRowView;
});
